import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Users, AlertCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

interface Mentee {
  id: string;
  mentee_name: string;
  academic_year: string;
  meetings_completed: number;
  required_meetings: number;
}

interface MenteesWidgetProps {
  mentees: Mentee[];
  loading?: boolean;
}

export function MenteesWidget({ mentees, loading }: MenteesWidgetProps) {
  const navigate = useNavigate();

  if (loading) {
    return (
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Users className="h-5 w-5" />
            My Mentees
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">Loading...</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Users className="h-5 w-5" />
          My Mentees ({mentees.length})
        </CardTitle>
      </CardHeader>
      <CardContent>
        {mentees.length === 0 ? (
          <p className="text-sm text-muted-foreground">No assigned mentees</p>
        ) : (
          <div className="space-y-3">
            {mentees.map((mentee) => {
              const progress = (mentee.meetings_completed / mentee.required_meetings) * 100;
              const isAtRisk = progress < 50;
              
              return (
                <div key={mentee.id} className="flex items-start justify-between border-b pb-2 last:border-0">
                  <div className="flex-1">
                    <div className="flex items-center gap-2">
                      <p className="font-medium text-sm">{mentee.mentee_name}</p>
                      {isAtRisk && <AlertCircle className="h-4 w-4 text-destructive" />}
                    </div>
                    <p className="text-xs text-muted-foreground">{mentee.academic_year}</p>
                    <p className="text-xs text-muted-foreground mt-1">
                      Meetings: {mentee.meetings_completed}/{mentee.required_meetings}
                    </p>
                  </div>
                </div>
              );
            })}
            <Button 
              variant="link" 
              size="sm" 
              className="w-full"
              onClick={() => navigate('/new-teacher-mentor-program')}
            >
              View mentor program
            </Button>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
